import '@angular/compiler';
import './polyfills';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";

if (environment.PRODUCTION && !environment.LOCAL) {
    enableProdMode();
}
if (!environment.LOCAL) {
    Sentry.init({
        dsn: "https://3f850bb620cb48cc8a8e0cd8c266e93a@o25812.ingest.sentry.io/1494891",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        environment: environment.STAGE,
        release: environment.VERSION,
        tracesSampleRate: 0.3,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0, // capture 100% of sessions with an error
    });
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(ref => {
        if (window['ngRef']) { // Ensure Angular destroys itself on hot reloads.
            window['ngRef'].destroy();
        }
        window['ngRef'] = ref;
    })
    .catch(err => {
        console.error('Handle bootstrap level error', err);
        window.location.reload();
    });
